module.exports = __webpack_public_path__ + "img/IMG_0328_FoamcoreMatted.65dbd5e1.jpg";